<div class="together">
  <div class="together__head">
    <div class="together__head-text">
      <h1 class="together__h1">{{ 'together.title' | translate }}</h1>
      <p class="together__subtitle">{{ 'together.subtitle' | translate }}</p>
    </div>
    @if (isOfficeOrAdmin) {
      <button type="button" class="together__new-btn" (click)="openNewComposer($event)">
        <mat-icon fontIcon="add"></mat-icon>
        {{ 'together.action.new' | translate }}
      </button>
    }
  </div>

  <div class="together__filter-row">
    <div class="together__chips">
      <button type="button" class="together__chip" [class.together__chip--active]="activeFilter === 'ALLE'" (click)="setFilter('ALLE')">
        {{ 'together.filter.all' | translate }}
      </button>
      <button type="button" class="together__chip" [class.together__chip--active]="activeFilter === 'MEILENSTEIN'" (click)="setFilter('MEILENSTEIN')">
        {{ 'together.category.MEILENSTEIN' | translate }}
      </button>
      <button type="button" class="together__chip" [class.together__chip--active]="activeFilter === 'HINWEIS'" (click)="setFilter('HINWEIS')">
        {{ 'together.category.HINWEIS' | translate }}
      </button>
    </div>
    <span class="together__count">{{ (filteredPosts.length === 1 ? 'together.count_one' : 'together.count_other') | translate: {n: filteredPosts.length} }}</span>
  </div>

  @if (deleteError) {
    <p class="together__error together__error--block" role="alert">{{ deleteError | translate }}</p>
  }
  @if (downloadError) {
    <p class="together__error together__error--block" role="alert">{{ downloadError | translate }}</p>
  }

  @if (loading) {
    <div class="together__loading"><mat-progress-spinner mode="indeterminate" diameter="40"></mat-progress-spinner></div>
  } @else if (loadError) {
    <div class="together__load-error">
      <p>{{ 'together.error.load' | translate }}</p>
      <button type="button" class="together__text-btn" (click)="loadPosts()">{{ 'together.error.retry' | translate }}</button>
    </div>
  } @else {
    <div class="together__timeline">
      @if (startYear !== null) {
        <div class="together__start-circle">{{ startYear }}</div>
      }
      @if (filteredPosts.length === 0) {
        <p class="together__empty">{{ 'together.empty' | translate }}</p>
      } @else {
        <ul class="together__list">
          @for (post of filteredPosts; track post.id; let i = $index) {
            <li class="together__row" [class.together__row--right]="isRight(i)" [class.together__row--left]="!isRight(i)">
              @if (isRight(i)) {
                <span class="together__date">{{ formatDate(post.datum) }}</span>
                <span class="together__dot" [ngClass]="'together__dot--' + (post.kategorie | lowercase)"></span>
                <div class="together__card" [class.together__card--with-image]="!!post.bild && imageUrls.has(post.id)">
                  <ng-container [ngTemplateOutlet]="cardContent" [ngTemplateOutletContext]="{post: post}"></ng-container>
                </div>
              } @else {
                <div class="together__card together__card--left" [class.together__card--with-image]="!!post.bild && imageUrls.has(post.id)">
                  <ng-container [ngTemplateOutlet]="cardContent" [ngTemplateOutletContext]="{post: post}"></ng-container>
                </div>
                <span class="together__dot" [ngClass]="'together__dot--' + (post.kategorie | lowercase)"></span>
                <span class="together__date together__date--left">{{ formatDate(post.datum) }}</span>
              }
            </li>
          }
        </ul>
      }
    </div>
  }
</div>

<ng-template #cardContent let-post="post">
  <div class="together__card-head">
    <span class="together__badge" [ngClass]="'together__badge--' + (post.kategorie | lowercase)">
      {{ 'together.category.' + post.kategorie | translate }}
    </span>
    @if (isOfficeOrAdmin) {
      <button type="button" class="together__edit-btn" [attr.aria-label]="'together.action.edit' | translate" (click)="openEditComposer(post, $event)">
        <mat-icon fontIcon="edit"></mat-icon>
      </button>
      <button type="button" class="together__delete-btn" [attr.aria-label]="'together.delete.aria' | translate" (click)="openDeleteConfirm(post)">
        <mat-icon fontIcon="delete"></mat-icon>
      </button>
    }
  </div>
  @if (!!post.bild && imageUrls.has(post.id)) {
    <div class="together__card-body--with-image">
      <div class="together__card-main">
        <h3 class="together__card-title">{{ post.titel }}</h3>
        <p class="together__card-text">{{ post.text }}</p>
        <ng-container [ngTemplateOutlet]="anhangPill" [ngTemplateOutletContext]="{post: post}"></ng-container>
      </div>
      <button #imgBtn type="button" class="together__image-btn" [attr.aria-label]="'together.zoom.aria' | translate: {name: post.bild?.beschreibung || post.titel}" (click)="openLightbox(post, imgBtn)">
        <img class="together__card-img" [src]="imageUrls.get(post.id)" alt="" />
        <span class="together__zoom-icon"><mat-icon fontIcon="zoom_in"></mat-icon></span>
      </button>
    </div>
  } @else {
    <h3 class="together__card-title">{{ post.titel }}</h3>
    <p class="together__card-text">{{ post.text }}</p>
    <ng-container [ngTemplateOutlet]="anhangPill" [ngTemplateOutletContext]="{post: post}"></ng-container>
  }
</ng-template>

<ng-template #anhangPill let-post="post">
  @if (post.anhang?.art === 'LINK') {
    <a class="together__pill" [href]="post.anhang?.ziel" target="_blank" rel="noopener noreferrer" [title]="post.anhang?.ziel">
      <mat-icon fontIcon="link" class="together__pill-icon"></mat-icon>
      <span class="together__pill-name">{{ post.anhang?.name }}</span>
    </a>
  } @else if (post.anhang?.art === 'PDF') {
    <a class="together__pill" href="#" [title]="(post.anhang?.name || '') + ' · PDF'" (click)="downloadPdf(post, $event)">
      <mat-icon fontIcon="description" class="together__pill-icon"></mat-icon>
      <span class="together__pill-name">{{ post.anhang?.name }}</span>
    </a>
  }
</ng-template>

<app-together-lightbox [open]="lightboxOpen" [imageUrl]="lightboxUrl" [titel]="lightboxTitel" [beschreibung]="lightboxBeschreibung" (close)="closeLightbox()"></app-together-lightbox>

<ng-template #composerModalContent>
  <div class="together__fields">
    <div class="together__field">
      <label class="together__label" for="composer-datum">{{ 'together.field.date' | translate }}</label>
      <input
        id="composer-datum"
        class="together__input"
        type="date"
        [(ngModel)]="composerDate"
        min="2000-01-01"
        max="2099-12-31"
        (change)="validateDate()"
      />
      @if (composerDateError) {
        <span class="together__error" role="alert">{{ composerDateError | translate }}</span>
      }
    </div>
    <div class="together__field together__field--category">
      <label class="together__label">{{ 'together.field.category' | translate }}</label>
      <div class="together__segment" role="group">
        <button type="button" class="together__segment-btn" [class.together__segment-btn--active]="composerKategorie === 'MEILENSTEIN'" (click)="composerKategorie = 'MEILENSTEIN'">
          {{ 'together.category.MEILENSTEIN' | translate }}
        </button>
        <button type="button" class="together__segment-btn" [class.together__segment-btn--active]="composerKategorie === 'HINWEIS'" (click)="composerKategorie = 'HINWEIS'">
          {{ 'together.category.HINWEIS' | translate }}
        </button>
      </div>
    </div>
    <div class="together__field together__field--title">
      <label class="together__label" for="composer-titel">{{ 'together.field.title' | translate }}</label>
      <input
        id="composer-titel"
        class="together__input"
        type="text"
        [placeholder]="'together.placeholder.title' | translate"
        [(ngModel)]="composerTitle"
        maxlength="150"
      />
    </div>
  </div>

  <div class="together__field together__field--full">
    <label class="together__label" for="composer-text">{{ 'together.field.text' | translate }}</label>
    <textarea
      id="composer-text"
      class="together__input together__textarea"
      [placeholder]="'together.placeholder.text' | translate"
      [(ngModel)]="composerText"
      maxlength="2000"
      rows="3"
    ></textarea>
  </div>

  <div class="together__attachment-box">
    <div class="together__attachment-section">
      <span class="together__attachment-heading">{{ 'together.attachment.heading' | translate }}</span>
      <p class="together__attachment-section-title">{{ 'together.attachment.docOrLink' | translate }}</p>
      <div class="together__segment" role="group">
        <button type="button" class="together__segment-btn" [class.together__segment-btn--active]="composerAnhangArt === 'KEIN_ANHANG'" (click)="onAnhangArtChange('KEIN_ANHANG')">
          {{ 'together.attachment.none' | translate }}
        </button>
        <button type="button" class="together__segment-btn" [class.together__segment-btn--active]="composerAnhangArt === 'PDF'" (click)="onAnhangArtChange('PDF')">
          {{ 'together.attachment.pdf' | translate }}
        </button>
        <button type="button" class="together__segment-btn" [class.together__segment-btn--active]="composerAnhangArt === 'LINK'" (click)="onAnhangArtChange('LINK')">
          {{ 'together.attachment.link' | translate }}
        </button>
      </div>

      @if (composerAnhangArt === 'PDF') {
        <div class="together__attachment-fields">
          <div class="together__field">
            <label class="together__label" for="composer-anzeigename">{{ 'together.attachment.displayName' | translate }}</label>
            <input id="composer-anzeigename" class="together__input together__input--limited" type="text" [placeholder]="'together.attachment.placeholderPdf' | translate" [(ngModel)]="composerAnzeigeName" maxlength="150" />
            <span class="together__hint">{{ 'together.attachment.hint' | translate }}</span>
          </div>
          <div class="together__field">
            <label class="together__label">{{ 'together.attachment.file' | translate }}</label>
            @if (composerPdfExistsOnServer && !composerPdf) {
              <div class="together__file-card">
                <span class="together__file-card-icon-wrap"><mat-icon fontIcon="picture_as_pdf"></mat-icon></span>
                <div class="together__file-card-info">
                  <span class="together__file-card-name">{{ editingPost?.anhang?.name }}</span>
                </div>
                <button type="button" class="together__remove-btn" (click)="removeExistingPdf(); $event.stopPropagation()">
                  <mat-icon fontIcon="close"></mat-icon>
                </button>
              </div>
            } @else if (composerPdf) {
              <div class="together__file-card">
                <span class="together__file-card-icon-wrap"><mat-icon fontIcon="picture_as_pdf"></mat-icon></span>
                <div class="together__file-card-info">
                  <span class="together__file-card-name">{{ composerPdf.name }}</span>
                  <span class="together__file-card-size">{{ pdfFileSize() }}</span>
                </div>
                <button type="button" class="together__remove-btn" (click)="removePdf(); $event.stopPropagation()">
                  <mat-icon fontIcon="close"></mat-icon>
                </button>
              </div>
            } @else {
              <app-file-dropzone variant="pdf" accept="application/pdf" [maxBytes]="pdfMax" (fileSelected)="onPdfSelected($event)" (fileRejected)="onPdfRejected($event)"></app-file-dropzone>
              @if (composerPdfError) {
                <span class="together__error" role="alert">{{ composerPdfError | translate }}</span>
              }
            }
          </div>
        </div>
      }

      @if (composerAnhangArt === 'LINK') {
        <div class="together__attachment-fields">
          <div class="together__field">
            <label class="together__label" for="composer-anzeigename-link">{{ 'together.attachment.displayName' | translate }}</label>
            <input id="composer-anzeigename-link" class="together__input together__input--limited" type="text" [placeholder]="'together.attachment.placeholderLink' | translate" [(ngModel)]="composerAnzeigeName" maxlength="150" />
          </div>
          <div class="together__field">
            <label class="together__label" for="composer-url">{{ 'together.attachment.url' | translate }}</label>
            <input id="composer-url" class="together__input together__input--limited" type="url" [(ngModel)]="composerUrl" (blur)="validateUrl()" maxlength="2000" />
            @if (composerUrlError) {
              <span class="together__error" role="alert">{{ composerUrlError | translate }}</span>
            }
          </div>
        </div>
      }
    </div>

    <div class="together__attachment-section together__attachment-section--image">
      <p class="together__attachment-section-title">
        {{ 'together.image.heading' | translate }}
        <span class="together__attachment-optional">{{ 'together.image.optional' | translate }}</span>
      </p>
      @if (composerImage && composerImagePreview) {
        <div class="together__image-chosen">
          <img class="together__image-preview" [src]="composerImagePreview" alt="" />
          <div class="together__image-info">
            <span class="together__file-card-name together__file-card-name--ellipsis">{{ composerImage.name }}</span>
            <div class="together__field">
              <label class="together__label" for="composer-img-desc">{{ 'together.image.description' | translate }}</label>
              <input id="composer-img-desc" class="together__input" type="text" [placeholder]="'together.image.placeholder' | translate" [(ngModel)]="composerImageDescription" maxlength="250" />
              <span class="together__hint">{{ 'together.image.hint' | translate }}</span>
            </div>
          </div>
          <div class="together__image-actions">
            <label class="together__text-btn" tabindex="0" role="button" (keydown.enter)="replaceImageInput.click()" (keydown.space)="replaceImageInput.click()">
              {{ 'together.image.replace' | translate }}
              <input #replaceImageInput type="file" accept="image/png,image/jpeg,image/webp,image/gif" class="together__replace-input" (change)="onReplaceImage($event)" />
            </label>
            <button type="button" class="together__remove-btn" (click)="removeImage(); $event.stopPropagation()">
              <mat-icon fontIcon="close"></mat-icon>
              {{ 'together.image.remove' | translate }}
            </button>
          </div>
        </div>
      } @else if (composerExistingBild && editingPost) {
        <div class="together__image-chosen">
          <img class="together__image-preview" [src]="imageUrls.get(editingPost.id)" alt="" />
          <div class="together__image-info">
            <span class="together__file-card-name together__file-card-name--ellipsis">{{ composerExistingBild.dateiName }}</span>
            <div class="together__field">
              <label class="together__label" for="composer-img-desc-existing">{{ 'together.image.description' | translate }}</label>
              <input id="composer-img-desc-existing" class="together__input" type="text" [placeholder]="'together.image.placeholder' | translate" [(ngModel)]="composerImageDescription" maxlength="250" />
              <span class="together__hint">{{ 'together.image.hint' | translate }}</span>
            </div>
          </div>
          <div class="together__image-actions">
            <label class="together__text-btn" tabindex="0" role="button" (keydown.enter)="replaceExistingImageInput.click()" (keydown.space)="replaceExistingImageInput.click()">
              {{ 'together.image.replace' | translate }}
              <input #replaceExistingImageInput type="file" accept="image/png,image/jpeg,image/webp,image/gif" class="together__replace-input" (change)="onReplaceImage($event)" />
            </label>
            <button type="button" class="together__remove-btn" (click)="removeExistingImage(); $event.stopPropagation()">
              <mat-icon fontIcon="close"></mat-icon>
              {{ 'together.image.remove' | translate }}
            </button>
          </div>
        </div>
      } @else {
        <app-file-dropzone variant="image" accept="image/png,image/jpeg,image/webp,image/gif" [maxBytes]="imageMax" (fileSelected)="onImageSelected($event)" (fileRejected)="onImageRejected($event)"></app-file-dropzone>
        @if (composerImageError) {
          <span class="together__error" role="alert">{{ composerImageError | translate }}</span>
        }
      }
    </div>
  </div>

  <div class="together__composer-footer">
    <span class="together__state-text">{{ 'together.state.' + stateText | translate }}</span>
    <div class="together__composer-actions">
      <button type="button" class="together__text-btn" (click)="discard()">{{ 'together.action.discard' | translate }}</button>
      <button type="button" class="together__primary-btn" [disabled]="!canPublish" (click)="publish()">
        @if (publishing) {
          <mat-progress-spinner diameter="16" mode="indeterminate"></mat-progress-spinner>
        }
        {{ (editingPost ? 'together.action.save' : 'together.action.publish') | translate }}
      </button>
    </div>
    @if (publishError) {
      <span class="together__error" role="alert">{{ publishError | translate }}</span>
    }
  </div>
</ng-template>

<ng-template #deleteModalContent>
  <p class="together__modal-text">{{ 'together.delete.confirmText' | translate: {titel: postToDelete?.titel} }}</p>
  <div class="together__modal-footer">
    <button type="button" class="together__text-btn" (click)="cancelDelete()">{{ 'general.cancel' | translate }}</button>
    <button type="button" class="together__primary-btn together__primary-btn--danger" (click)="confirmDelete()">{{ 'general.delete' | translate }}</button>
  </div>
</ng-template>

<app-modal
  [modalId]="composerModalId"
  [title]="editingPost ? 'together.dialog.titleEdit' : 'together.dialog.titleNew'"
  [showButtons]="false"
  [contentTemplate]="composerModalContent"
  [triggerElement]="composerTrigger"
  (cancel)="discard()"
></app-modal>

<app-modal
  [modalId]="deleteModalId"
  [title]="'together.delete.confirmTitle'"
  [showButtons]="false"
  [contentTemplate]="deleteModalContent"
  (cancel)="cancelDelete()"
></app-modal>
